import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { OrderProduct } from './order-product';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class OrderProductService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];

	applyStaysOfNtsList: any = [
		{ value: 0, name: 'No Limits' },
		{ value: 1, name: '1 Night' },
		{ value: 2, name: '2 Nights' },
		{ value: 3, name: '3 Nights' },
		{ value: 4, name: '4 Nights' },
		{ value: 5, name: '5 Nights' },
		{ value: 6, name: '6 Nights' },
		{ value: 7, name: '7 Nights' },
		{ value: 8, name: '8 Nights' },
		{ value: 9, name: '9 Nights' },
		{ value: 10, name: '10 Nights' },
		{ value: 11, name: '11 Nights' },
		{ value: 12, name: '12 Nights' },
		{ value: 13, name: '13 Nights' },
		{ value: 14, name: '14 Nights' },
		{ value: 15, name: '15 Nights' },
		{ value: 16, name: '16 Nights' },
		{ value: 17, name: '17 Nights' },
		{ value: 18, name: '18 Nights' },
		{ value: 19, name: '19 Nights' },
		{ value: 20, name: '20 Nights' },
		{ value: 21, name: '21 Nights' },
		{ value: 22, name: '22 Nights' },
		{ value: 23, name: '23 Nights' },
		{ value: 24, name: '24 Nights' },
		{ value: 25, name: '25 Nights' },
		{ value: 26, name: '26 Nights' },
		{ value: 27, name: '27 Nights' },
		{ value: 28, name: '28 Nights' },
		{ value: 29, name: '29 Nights' },
		{ value: 30, name: '30 Nights' },
		{ value: 31, name: '31 Nights' },
		{ value: 32, name: '32 Nights' },
		{ value: 33, name: '33 Nights' },
		{ value: 34, name: '34 Nights' },
		{ value: 35, name: '35 Nights' },
		{ value: 36, name: '36 Nights' },
		{ value: 37, name: '37 Nights' },
		{ value: 38, name: '38 Nights' },
		{ value: 39, name: '39 Nights' },
		{ value: 40, name: '40 Nights' },
		{ value: 41, name: '41 Nights' },
		{ value: 42, name: '42 Nights' },
		{ value: 43, name: '43 Nights' },
		{ value: 44, name: '44 Nights' },
		{ value: 45, name: '45 Nights' },
		{ value: 46, name: '46 Nights' },
		{ value: 47, name: '47 Nights' },
		{ value: 48, name: '48 Nights' },
		{ value: 49, name: '49 Nights' },
		{ value: 50, name: '50 Nights' },
		{ value: 51, name: '51 Nights' },
		{ value: 52, name: '52 Nights' },
		{ value: 53, name: '53 Nights' },
		{ value: 54, name: '54 Nights' },
		{ value: 55, name: '55 Nights' },
		{ value: 56, name: '56 Nights' },
		{ value: 57, name: '57 Nights' },
		{ value: 58, name: '58 Nights' },
		{ value: 59, name: '59 Nights' },
		{ value: 60, name: '60 Nights' },
		{ value: 61, name: '61 Nights' },
		{ value: 62, name: '62 Nights' },
		{ value: 63, name: '63 Nights' },
		{ value: 64, name: '64 Nights' },
		{ value: 65, name: '65 Nights' },
		{ value: 66, name: '66 Nights' },
		{ value: 67, name: '67 Nights' },
		{ value: 68, name: '68 Nights' },
		{ value: 69, name: '69 Nights' },
		{ value: 70, name: '70 Nights' },
		{ value: 71, name: '71 Nights' },
		{ value: 72, name: '72 Nights' },
		{ value: 73, name: '73 Nights' },
		{ value: 74, name: '74 Nights' },
		{ value: 75, name: '75 Nights' },
		{ value: 76, name: '76 Nights' },
		{ value: 77, name: '77 Nights' },
		{ value: 78, name: '78 Nights' },
		{ value: 79, name: '79 Nights' },
		{ value: 80, name: '80 Nights' },
		{ value: 81, name: '81 Nights' },
		{ value: 82, name: '82 Nights' },
		{ value: 83, name: '83 Nights' },
		{ value: 84, name: '84 Nights' },
		{ value: 85, name: '85 Nights' },
		{ value: 86, name: '86 Nights' },
		{ value: 87, name: '87 Nights' },
		{ value: 88, name: '88 Nights' },
		{ value: 89, name: '89 Nights' },
		{ value: 90, name: '90 Nights' },
		{ value: 91, name: '91 Nights' },
		{ value: 92, name: '92 Nights' },
		{ value: 93, name: '93 Nights' },
		{ value: 94, name: '94 Nights' },
		{ value: 95, name: '95 Nights' },
		{ value: 96, name: '96 Nights' },
		{ value: 97, name: '97 Nights' },
		{ value: 98, name: '98 Nights' },
		{ value: 99, name: '99 Nights' },
		{ value: 100, name: '100 Nights' },
		{ value: 101, name: '101 Nights' },
		{ value: 102, name: '102 Nights' },
		{ value: 103, name: '103 Nights' },
		{ value: 104, name: '104 Nights' },
		{ value: 105, name: '105 Nights' },
		{ value: 106, name: '106 Nights' },
		{ value: 107, name: '107 Nights' },
		{ value: 108, name: '108 Nights' },
		{ value: 109, name: '109 Nights' },
		{ value: 110, name: '110 Nights' },
		{ value: 111, name: '111 Nights' },
		{ value: 112, name: '112 Nights' },
		{ value: 113, name: '113 Nights' },
		{ value: 114, name: '114 Nights' },
		{ value: 115, name: '115 Nights' },
		{ value: 116, name: '116 Nights' },
		{ value: 117, name: '117 Nights' },
		{ value: 118, name: '118 Nights' },
		{ value: 119, name: '119 Nights' },
		{ value: 120, name: '120 Nights' },
		{ value: 121, name: '121 Nights' },
		{ value: 122, name: '122 Nights' },
		{ value: 123, name: '123 Nights' },
		{ value: 124, name: '124 Nights' },
		{ value: 125, name: '125 Nights' },
		{ value: 126, name: '126 Nights' },
		{ value: 127, name: '127 Nights' },
		{ value: 128, name: '128 Nights' },
		{ value: 129, name: '129 Nights' },
		{ value: 130, name: '130 Nights' },
		{ value: 131, name: '131 Nights' },
		{ value: 132, name: '132 Nights' },
		{ value: 133, name: '133 Nights' },
		{ value: 134, name: '134 Nights' },
		{ value: 135, name: '135 Nights' },
		{ value: 136, name: '136 Nights' },
		{ value: 137, name: '137 Nights' },
		{ value: 138, name: '138 Nights' },
		{ value: 139, name: '139 Nights' },
		{ value: 140, name: '140 Nights' },
		{ value: 141, name: '141 Nights' },
		{ value: 142, name: '142 Nights' },
		{ value: 143, name: '143 Nights' },
		{ value: 144, name: '144 Nights' },
		{ value: 145, name: '145 Nights' },
		{ value: 146, name: '146 Nights' },
		{ value: 147, name: '147 Nights' },
		{ value: 148, name: '148 Nights' },
		{ value: 149, name: '149 Nights' },
		{ value: 150, name: '150 Nights' },
		{ value: 151, name: '151 Nights' },
		{ value: 152, name: '152 Nights' },
		{ value: 153, name: '153 Nights' },
		{ value: 154, name: '154 Nights' },
		{ value: 155, name: '155 Nights' },
		{ value: 156, name: '156 Nights' },
		{ value: 157, name: '157 Nights' },
		{ value: 158, name: '158 Nights' },
		{ value: 159, name: '159 Nights' },
		{ value: 160, name: '160 Nights' },
		{ value: 161, name: '161 Nights' },
		{ value: 162, name: '162 Nights' },
		{ value: 163, name: '163 Nights' },
		{ value: 164, name: '164 Nights' },
		{ value: 165, name: '165 Nights' },
		{ value: 166, name: '166 Nights' },
		{ value: 167, name: '167 Nights' },
		{ value: 168, name: '168 Nights' },
		{ value: 169, name: '169 Nights' },
		{ value: 170, name: '170 Nights' },
		{ value: 171, name: '171 Nights' },
		{ value: 172, name: '172 Nights' },
		{ value: 173, name: '173 Nights' },
		{ value: 174, name: '174 Nights' },
		{ value: 175, name: '175 Nights' },
		{ value: 176, name: '176 Nights' },
		{ value: 177, name: '177 Nights' },
		{ value: 178, name: '178 Nights' },
		{ value: 179, name: '179 Nights' },
		{ value: 180, name: '180 Nights' },
		{ value: 181, name: '181 Nights' },
		{ value: 182, name: '182 Nights' },
		{ value: 183, name: '183 Nights' },
		{ value: 184, name: '184 Nights' },
		{ value: 185, name: '185 Nights' },
		{ value: 186, name: '186 Nights' },
		{ value: 187, name: '187 Nights' },
		{ value: 188, name: '188 Nights' },
		{ value: 189, name: '189 Nights' },
		{ value: 190, name: '190 Nights' },
		{ value: 191, name: '191 Nights' },
		{ value: 192, name: '192 Nights' },
		{ value: 193, name: '193 Nights' },
		{ value: 194, name: '194 Nights' },
		{ value: 195, name: '195 Nights' },
		{ value: 196, name: '196 Nights' },
		{ value: 197, name: '197 Nights' },
		{ value: 198, name: '198 Nights' },
		{ value: 199, name: '199 Nights' },
		{ value: 200, name: '200 Nights' },
		{ value: 201, name: '201 Nights' },
		{ value: 202, name: '202 Nights' },
		{ value: 203, name: '203 Nights' },
		{ value: 204, name: '204 Nights' },
		{ value: 205, name: '205 Nights' },
		{ value: 206, name: '206 Nights' },
		{ value: 207, name: '207 Nights' },
		{ value: 208, name: '208 Nights' },
		{ value: 209, name: '209 Nights' },
		{ value: 210, name: '210 Nights' },
		{ value: 211, name: '211 Nights' },
		{ value: 212, name: '212 Nights' },
		{ value: 213, name: '213 Nights' },
		{ value: 214, name: '214 Nights' },
		{ value: 215, name: '215 Nights' },
		{ value: 216, name: '216 Nights' },
		{ value: 217, name: '217 Nights' },
		{ value: 218, name: '218 Nights' },
		{ value: 219, name: '219 Nights' },
		{ value: 220, name: '220 Nights' },
		{ value: 221, name: '221 Nights' },
		{ value: 222, name: '222 Nights' },
		{ value: 223, name: '223 Nights' },
		{ value: 224, name: '224 Nights' },
		{ value: 225, name: '225 Nights' },
		{ value: 226, name: '226 Nights' },
		{ value: 227, name: '227 Nights' },
		{ value: 228, name: '228 Nights' },
		{ value: 229, name: '229 Nights' },
		{ value: 230, name: '230 Nights' },
		{ value: 231, name: '231 Nights' },
		{ value: 232, name: '232 Nights' },
		{ value: 233, name: '233 Nights' },
		{ value: 234, name: '234 Nights' },
		{ value: 235, name: '235 Nights' },
		{ value: 236, name: '236 Nights' },
		{ value: 237, name: '237 Nights' },
		{ value: 238, name: '238 Nights' },
		{ value: 239, name: '239 Nights' },
		{ value: 240, name: '240 Nights' },
		{ value: 241, name: '241 Nights' },
		{ value: 242, name: '242 Nights' },
		{ value: 243, name: '243 Nights' },
		{ value: 244, name: '244 Nights' },
		{ value: 245, name: '245 Nights' },
		{ value: 246, name: '246 Nights' },
		{ value: 247, name: '247 Nights' },
		{ value: 248, name: '248 Nights' },
		{ value: 249, name: '249 Nights' },
		{ value: 250, name: '250 Nights' },
		{ value: 251, name: '251 Nights' },
		{ value: 252, name: '252 Nights' },
		{ value: 253, name: '253 Nights' },
		{ value: 254, name: '254 Nights' },
		{ value: 255, name: '255 Nights' },
		{ value: 256, name: '256 Nights' },
		{ value: 257, name: '257 Nights' },
		{ value: 258, name: '258 Nights' },
		{ value: 259, name: '259 Nights' },
		{ value: 260, name: '260 Nights' },
		{ value: 261, name: '261 Nights' },
		{ value: 262, name: '262 Nights' },
		{ value: 263, name: '263 Nights' },
		{ value: 264, name: '264 Nights' },
		{ value: 265, name: '265 Nights' },
		{ value: 266, name: '266 Nights' },
		{ value: 267, name: '267 Nights' },
		{ value: 268, name: '268 Nights' },
		{ value: 269, name: '269 Nights' },
		{ value: 270, name: '270 Nights' },
		{ value: 271, name: '271 Nights' },
		{ value: 272, name: '272 Nights' },
		{ value: 273, name: '273 Nights' },
		{ value: 274, name: '274 Nights' },
		{ value: 275, name: '275 Nights' },
		{ value: 276, name: '276 Nights' },
		{ value: 277, name: '277 Nights' },
		{ value: 278, name: '278 Nights' },
		{ value: 279, name: '279 Nights' },
		{ value: 280, name: '280 Nights' },
		{ value: 281, name: '281 Nights' },
		{ value: 282, name: '282 Nights' },
		{ value: 283, name: '283 Nights' },
		{ value: 284, name: '284 Nights' },
		{ value: 285, name: '285 Nights' },
		{ value: 286, name: '286 Nights' },
		{ value: 287, name: '287 Nights' },
		{ value: 288, name: '288 Nights' },
		{ value: 289, name: '289 Nights' },
		{ value: 290, name: '290 Nights' },
		{ value: 291, name: '291 Nights' },
		{ value: 292, name: '292 Nights' },
		{ value: 293, name: '293 Nights' },
		{ value: 294, name: '294 Nights' },
		{ value: 295, name: '295 Nights' },
		{ value: 296, name: '296 Nights' },
		{ value: 297, name: '297 Nights' },
		{ value: 298, name: '298 Nights' },
		{ value: 299, name: '299 Nights' },
		{ value: 300, name: '300 Nights' },
		{ value: 301, name: '301 Nights' },
		{ value: 302, name: '302 Nights' },
		{ value: 303, name: '303 Nights' },
		{ value: 304, name: '304 Nights' },
		{ value: 305, name: '305 Nights' },
		{ value: 306, name: '306 Nights' },
		{ value: 307, name: '307 Nights' },
		{ value: 308, name: '308 Nights' },
		{ value: 309, name: '309 Nights' },
		{ value: 310, name: '310 Nights' },
		{ value: 311, name: '311 Nights' },
		{ value: 312, name: '312 Nights' },
		{ value: 313, name: '313 Nights' },
		{ value: 314, name: '314 Nights' },
		{ value: 315, name: '315 Nights' },
		{ value: 316, name: '316 Nights' },
		{ value: 317, name: '317 Nights' },
		{ value: 318, name: '318 Nights' },
		{ value: 319, name: '319 Nights' },
		{ value: 320, name: '320 Nights' },
		{ value: 321, name: '321 Nights' },
		{ value: 322, name: '322 Nights' },
		{ value: 323, name: '323 Nights' },
		{ value: 324, name: '324 Nights' },
		{ value: 325, name: '325 Nights' },
		{ value: 326, name: '326 Nights' },
		{ value: 327, name: '327 Nights' },
		{ value: 328, name: '328 Nights' },
		{ value: 329, name: '329 Nights' },
		{ value: 330, name: '330 Nights' },
		{ value: 331, name: '331 Nights' },
		{ value: 332, name: '332 Nights' },
		{ value: 333, name: '333 Nights' },
		{ value: 334, name: '334 Nights' },
		{ value: 335, name: '335 Nights' },
		{ value: 336, name: '336 Nights' },
		{ value: 337, name: '337 Nights' },
		{ value: 338, name: '338 Nights' },
		{ value: 339, name: '339 Nights' },
		{ value: 340, name: '340 Nights' },
		{ value: 341, name: '341 Nights' },
		{ value: 342, name: '342 Nights' },
		{ value: 343, name: '343 Nights' },
		{ value: 344, name: '344 Nights' },
		{ value: 345, name: '345 Nights' },
		{ value: 346, name: '346 Nights' },
		{ value: 347, name: '347 Nights' },
		{ value: 348, name: '348 Nights' },
		{ value: 349, name: '349 Nights' },
		{ value: 350, name: '350 Nights' },
		{ value: 351, name: '351 Nights' },
		{ value: 352, name: '352 Nights' },
		{ value: 353, name: '353 Nights' },
		{ value: 354, name: '354 Nights' },
		{ value: 355, name: '355 Nights' },
		{ value: 356, name: '356 Nights' },
		{ value: 357, name: '357 Nights' },
		{ value: 358, name: '358 Nights' },
		{ value: 359, name: '359 Nights' },
		{ value: 360, name: '360 Nights' },
		{ value: 361, name: '361 Nights' },
		{ value: 362, name: '362 Nights' },
		{ value: 363, name: '363 Nights' },
		{ value: 364, name: '364 Nights' },
		{ value: 365, name: '365 Nights' },

	];

	feeTypes: any = [
		{ value: 0, name: 'Not Applicable' },
		{ value: 1, name: 'Mandatory' },
		{ value: 2, name: 'Optional' },
	];

	feeFrequencies: any = [
		{ value: 1, name: 'Per Reservation' },
		{ value: 2, name: 'Per Night' },
		{ value: 3, name: 'Per Adult' },
		{ value: 4, name: 'Per Pet' },
		{ value: 5, name: 'Per Car' },
	];

	// Date: 2026-04-09 Author: Alkesh PCT base amount options for valuePCTAppliedTo
	valuePCTAppliedToOptions: any = [
		{ value: 1, name: 'Invoice Grand Total' },
		{ value: 2, name: 'Invoice Sub Total' },
		{ value: 3, name: 'Invoice Tax Amount' },
		{ value: 4, name: 'Nightly Rate Total (with tax)' },
		{ value: 5, name: 'Nightly Sub Total (without tax)' },
	];

	filters: any = [
		{ value: 'propertyCode', name: 'Property Code' },
		{ value: 'adrCity', name: 'City' },
		{ value: 'adrState', name: 'State' },
		{ value: 'adrCounty', name: 'County' },
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'order-products';

	add(orderProduct: OrderProduct): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(orderProduct));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, orderProduct);
	}

	update(orderProduct: OrderProduct): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, orderProduct);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`);
	}

	findInvoiceOrderProduct(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/invoice/list`);
	}

	findPropertyInvoiceOrderProduct(shortTermRentalId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/invoice/list/${shortTermRentalId}`);
	}

	findLedgerOrderProduct(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ledger/list`);
	}

	findAllOrderProducts(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
